import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import { AbstractImmoOverviewComponent } from '../abstract-immo-overview.component';
import { SubProjectImmoDelayed } from '../../../../model/project/sub-project-immo-delayed';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { FilterStoreService } from 'src/app/services/filter-store.service';
import { PageIndexService } from 'src/app/services/page-index-service';
import { SubProjectControllerRequestService } from 'src/app/services/api/sub-project-controller-request.service';
import { ModalService } from 'src/app/services/modal.service';
import { Router } from '@angular/router';
import { Lightbox } from 'ngx-lightbox';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import DateHelper from 'src/app/helpers/date-helper';
import { ReleaseFromDelayControllerRequestService } from 'src/app/services/api/release-from-delay/release-from-delay-controller-request.service';

@Component({
  selector: 'delayed-immo-overview',
  templateUrl: '../abstract-immo-overview.component.html',
  styleUrls: ['../abstract-immo-overview.component.scss'],
})
export class DelayedImmoOverviewComponent extends AbstractImmoOverviewComponent<SubProjectImmoDelayed> {
  @Output()
  countChange = new EventEmitter<number>();

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    protected filterStoreService: FilterStoreService,
    protected pageIndexService: PageIndexService,
    protected cd: ChangeDetectorRef,
    protected subProjectService: SubProjectControllerRequestService,
    protected modalService: ModalService,
    protected _lightbox: Lightbox,
    protected router: Router,
    protected releaseFromDelayControllerRequestService: ReleaseFromDelayControllerRequestService
  ) {
    super(
      [
        {
          key: 'project__id',
          active: false,
          strictEquality: true,
          numeric: true,
        },
        {
          key: 'immoNewCustomerName',
          active: false,
          strictEquality: false,
          numeric: false,
        },
        {
          key: 'projectPlacement__address',
          active: false,
          strictEquality: true,
          numeric: false,
        },
        {
          key: 'stockAtBranch',
          active: false,
          strictEquality: false,
          numeric: false,
        },
      ],
      filterStoreService,
      pageIndexService,
      cd,
      subProjectService,
      _lightbox,
      router
    );

    super.showDelete = false;
    super.showReleaseFromDelay = true;
  }

  public openTour(subProject: SubProjectImmoDelayed): void {
    throw new Error('Method not implemented.');
  }
  public copyProjectId(subProject: SubProjectImmoDelayed): void {
    throw new Error('Method not implemented.');
  }
  protected getPaginator(): MatPaginator {
    return this.paginator;
  }

  protected getLocalStorageKey(): string {
    return 'DelayedImmoOverviewComponent';
  }

  protected initDisplayedColumns(): void {
    this.displayedColumns = [
      'projectId',
      'delayedAt',
      'handleDelayByDate',
      'delayHandler',
      'customerNameAndAddress',
      'delayedReason',
      'branch',
      'kind',
      'measurements',
      'type',
      'displayStatus',
      'dropdownActions',
    ];
  }

  protected initSortSettings(): void {
    this.sortColumn = 'delayedRegistration.date';
    this.sortAscending = true;
  }

  protected fetchItems(): void {
    this.loading = true;
    this.items = [];

    this.subProjectService
      .getImmoDelayed(
        this.generateFilterString(),
        this.sortColumn,
        this.sortAscending,
        this.paginator.pageSize,
        this.paginator.pageIndex,
        false
      )
      .then((res) => {
        this.processPageResult(res);
        this.totalItems = res.totalItems;
        this.countChange.emit(this.totalItems);
        this.parseFetchedItems(res.items);
        this.items = res.items;
      })
      .finally(() => (this.loading = false));
  }

  private parseFetchedItems(items: SubProjectImmoDelayed[]): void {
    items.forEach((item) => {
      if (
        item.project != null &&
        CollectionHelper.isPopulated(item.project.ipBoards)
      ) {
        item.project.firstIpBoard = item.project.ipBoards[0];
      }

      this.calculateStatusClass(item);
    });
  }

  private calculateStatusClass(item: SubProjectImmoDelayed): void {
    if (item.handleDelayByDate != null) {
      const dateHasPassed = DateHelper.parseMoment(
        item.handleDelayByDate
      ).isBefore(this.today, 'day');
      if (dateHasPassed) {
        item.statusClass = 'on-hold';
        return;
      }
    }

    item.statusClass =
      item.project != null && item.project.collaborative ? 'collab' : 'new';
  }

  public openProject(subProject: SubProjectImmoDelayed): void {
    this.router.navigate([
      '/job',
      subProject.project == null ? null : subProject.project.id,
      subProject.id,
    ]);
  }

  public releaseFromDelay(subProject: SubProjectImmoDelayed): void {
    this.modalService.confirmDialog(
      'Opdracht vrijgeven',
      `Bent u zeker dat u opdracht #${subProject.project.id} wilt vrijgeven?`,
      (b) => {
        if (b) {
          this.doReleaseFromDelay(subProject);
        }
      }
    );
  }

  private doReleaseFromDelay(subProject: SubProjectImmoDelayed): void {
    this.loading = true;
    this.releaseFromDelayControllerRequestService
      .releaseSubProjectFromDelay(subProject.id)
      .then(() => this.fetchItems())
      .catch((err) => {
        this.loading = false;
        throw err;
      });
  }
}
